// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"527":"67b58513","530":"15f45338"}[chunkId] + ".chunk.js";
};